/**
 * Check buttons list component script
 */
export const CheckButtonsMulti = (function () {
  var init = function () {
    $(".btn-group-toggle.check-buttons-multi > .switchme")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("btn-primary");
        $(this).toggleClass("btn-light");

        if ($(this).hasClass("btn-primary")) {
          $(this).find(".check-buttons-multi-check").attr("checked", "checked");
        } else {
          $(this).find(".check-buttons-multi-check").removeAttr("checked");
        }
        return;
      });
  };

  return {
    init: init,
  };
})();
